
export default {
  name: 'PDPSearch',
  props: {
    comment: {
      type: String,
      default: '',
    },
    showModMessage: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '',
    },
    searchCount: {
      type: Number,
      default: 0,
    },
    commentTypeTitleLc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      searchTerm: '',
      showResults: false,
      currentSearchTerm: '',
    };
  },
  computed: {
    parseCommentBody() {
      return this.comment.split(/\r\n?|\n/).filter((i) => i);
    },
  },
  methods: {
    onClickClear() {
      this.showResults = false;
      this.searchTerm = '';
      this.currentSearchTerm = '';
      this.$emit('on-search-submit', '');
    },
    onClickSearch() {
      if (this.searchTerm) {
        this.showResults = true;
        this.currentSearchTerm = this.searchTerm;
        this.$emit('on-search-submit', this.searchTerm);
        return;
      }

      if (this.currentSearchTerm) {
        this.onClickClear();
      }
    },
  },
};
